import { styled } from "@linaria/react"
import { useMemo } from "react"

import { CodeFileLight, Icon20 } from "@/icons/Icons.ts"

export const FileMention = (props: {
  url: string
}) => {
  const filename = useMemo(() => {
    const path = props.url.substring(props.url.lastIndexOf("/") + 1)
    return path.length === 0 ? "/" : path
  }, [props.url])
  return (
    <Container>
      <CodeFileLight className={Icon20} />
      {filename}
    </Container>
  )
}

const Container = styled.span`
  display: inline-flex;
  vertical-align: bottom;

  color: var(--secondary-text-color);
`